import { createRoot } from 'react-dom/client';

import FamilyHomeContainer from 'components/familyHome/FamilyHomeContainer';

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('family-home-app');
  if (container) {
    const sections = JSON.parse(container.dataset.sections);
    const root = createRoot(container);
    root.render(<FamilyHomeContainer sectionsData={sections} />);
  }
});
